import { faker } from "@faker-js/faker";

export default function App() {
  return (
    <div className="App">
    	<img src={faker.internet.avatar()}/>
    </div>
  );
}
